export type ReportConfig = {
  _id: string;
  report_type: string;
  companies: string[];
  label: {
    [key: string]: string;
  };
  parameters: {
    [key: string]: any;
  };
  version?: number | null;
};


export enum ReportConfigsColumn {
    Id = "_id",
    ReportType = "report_type",
    Version = "version",
    StoreRawData = "store_raw_data",
    Companies = "companies",
    Created = "created",
    Modified = "modified",
    Actions = "actions"
  }
  